import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['item']

  connect() {
    this.timeout = setTimeout(() => this.removeAll(), 4000)
  }

  disconnect() {
    clearTimeout(this.timeout)
  }

  dismiss(event) {
    const toast = event.target.closest('.dg-toast')
    if (toast) {
      toast.style.opacity = '0'
      toast.style.transform = 'translateY(12px)'
      toast.style.transition = 'all 0.2s ease'
      setTimeout(() => toast.remove(), 200)
    }
  }

  removeAll() {
    this.itemTargets.forEach((toast) => {
      toast.style.opacity = '0'
      toast.style.transform = 'translateY(12px)'
      toast.style.transition = 'all 0.2s ease'
      setTimeout(() => toast.remove(), 200)
    })
  }
}
